<template>
  <div id="Table">
    <el-table
        stripe
        height
        border
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" label="序号"> </el-table-column>
      <el-table-column label="姓名" width="120">
        <template slot-scope="scope">{{ scope.row.date }}</template>
      </el-table-column>
      <el-table-column prop="name" label="批次" width="120"> </el-table-column>
      <el-table-column prop="address" label="工种" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="name" label="等级" width="120"> </el-table-column>
      <el-table-column prop="name" label="科目" width="120"> </el-table-column>
      <el-table-column prop="name" label="手机号" width="120"> </el-table-column>
      <el-table-column prop="name" label="报名时间" width="120"> </el-table-column>
      <el-table-column prop="name" label="交费类别" width="120"> </el-table-column>
      <el-table-column prop="name" label="支付方式" width="120"> </el-table-column>
      <el-table-column prop="name" label="支付凭证" width="120"> </el-table-column>
      <el-table-column prop="name" label="报名审核结果" width="120"> </el-table-column>
      <el-table-column prop="name" label="操作" width="120"> </el-table-column>
      <el-table-column prop="name" label="操作" width="120"> </el-table-column>

    </el-table>
    
  </div>
</template>

<script>
export default {
    name:"Table",
  data() {
    return {
      tableData: [
        {
          date: "2016-05-03",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
        },
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
        },
        {
          date: "2016-05-08",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
        },
        {
          date: "2016-05-06",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
        },
        {
          date: "2016-05-07",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
        },
      ],
      multipleSelection: [],
    };
  },

  methods: {
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  },
};
</script>


<style>
</style>